import { createAction, props } from '@ngrx/store';

import { SemanticRuleListEntity } from '../components/semantic-rule-list/semantic-rule-list.entity';

export enum SemanticRuleActions {
	InitSemanticRuleList = '[SemanticRule] get semantic rule list',
	RefreshSemanticRuleList = '[BE][SemanticRule] refresh semantic rule list',
	FetchSemanticRuleListFail = '[SemanticRule] fetch semantic rule list fail',
	FetchSemanticRuleListSuccess = '[SemanticRule] fetch semantic rule list success',
	OpenDeleteConfirmationPopup = '[SemanticRule] open delete confirm popup',
	DeleteSemanticRule = '[SemanticRule] delete semantic rule',
	DeleteSemanticRuleFail = '[BE][SemanticRule] delete semantic rule fail',
}

export const initSemanticRuleList = createAction(
	SemanticRuleActions.InitSemanticRuleList
);

export const refreshSemanticRuleList = createAction(
	SemanticRuleActions.RefreshSemanticRuleList
);

export const fetchSemanticRuleListSuccess = createAction(
	SemanticRuleActions.FetchSemanticRuleListSuccess,
	props<{ semanticRuleList: SemanticRuleListEntity }>()
);

export const fetchSemanticRuleListFail = createAction(
	SemanticRuleActions.FetchSemanticRuleListFail,
	props<{ error: unknown }>()
);

export const openDeleteConfirmationPopup = createAction(
	SemanticRuleActions.OpenDeleteConfirmationPopup,
	props<{ semanticRuleId: Array<number>; semanticRuleLabel: string }>()
);

export const deleteSemanticRule = createAction(
	SemanticRuleActions.DeleteSemanticRule,
	props<{ semanticRuleId: number }>()
);

export const deleteSemanticRuleFail = createAction(
	SemanticRuleActions.DeleteSemanticRuleFail,
	props<{ error: unknown }>()
);
